import request from '../libs/request';

const res = 'TaskQueue';

export default {
  execute(id) {
    return request({
      url: `api/${res}/execute`,
      method: 'post',
      data: {
        id
      }
    });
  },
  cancel(id) {
    return request({
      url: `api/${res}/cancel`,
      method: 'post',
      data: {
        id
      }
    });
  }
};
